<p-button
  icon="pi pi-table"
  [pTooltip]="'column-selector.colunas' | translate"
  tooltipPosition="top"
  (click)="op.toggle($event)"
  styleClass="p-button-outlined column-selector-btn">
</p-button>

<p-overlayPanel #op [showCloseIcon]="true" appendTo="body" styleClass="column-selector-panel">
  <!-- Header -->
  <div class="column-selector-header">
    <i class="pi pi-columns"></i>
    <span>{{ 'column-selector.colunas' | translate }}</span>
  </div>

  <!-- Lista de colunas -->
  <div class="column-selector-body">
    <div *ngFor="let col of columns; trackBy: trackByKey" class="column-item">
      <p-checkbox
        [inputId]="col.key"
        [binary]="true"
        [(ngModel)]="col.visible"
        [disabled]="col.fixed"
        (onChange)="onColumnToggle(col)">
      </p-checkbox>
      <label [for]="col.key" class="column-label">
        {{ col.labelKey | translate }}
        <span *ngIf="col.fixed" class="fixed-badge">
          {{ 'column-selector.fixo' | translate }}
        </span>
      </label>
    </div>
  </div>

  <!-- Footer -->
  <div class="column-selector-footer">
    <span class="column-count">
      {{ visibleCount }} {{ 'column-selector.de' | translate }} {{ totalCount }}
      {{ 'column-selector.colunas_visiveis' | translate }}
    </span>
    <p-button
      [label]="'column-selector.restaurar' | translate"
      icon="pi pi-refresh"
      styleClass="p-button-text p-button-sm"
      (click)="restore()">
    </p-button>
  </div>
</p-overlayPanel>
